import { render, staticRenderFns } from "./OpenTag.vue?vue&type=template&id=26727092&scoped=true"
import script from "./OpenTag.vue?vue&type=script&lang=js"
export * from "./OpenTag.vue?vue&type=script&lang=js"
import style0 from "./OpenTag.vue?vue&type=style&index=0&id=26727092&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26727092",
  null
  
)

export default component.exports